export function GoldenAge({ goldenAgeLevel, current, levels }) {

    let levelRequirement = levels[goldenAgeLevel - 1] || levels[0]
    current = current || 0

    let widthHeight = "w-[40px] h-[40px]"
    let textClass = "text-2xl w-[40px] h-[40px] flex text-center justify-center align-center items-center"
    return (
        <div className="w-[84px] h-[40px] border-solid border flex flex-row justify-center" style={{ color: "#F7D79E", borderColor: 'var(--main-color)', backgroundImage: 'url("/sheepCounter/background.png")' }}>
            <div className="flex flex-row items-center w-[40px] justify-end mr-[2px]">
                <h1 className="text-white text-lg">{current}</h1>
                <h1 className="text-[#b1b1b1] italic text-sm">/{levelRequirement}</h1>
            </div>
            <div className='w-10' style={{ "--mask-step": goldenAgeLevel }}>
                <img className={`absolute ${widthHeight} -mt-[1px] -ml-[1px]`} src="/GoldenAge/golden_age_icon.png" />
                <div className={`absolute -mt-[1px] -ml-[1px] ${textClass} ${widthHeight}`}>
                    <h1 className={``}>{goldenAgeLevel}</h1>
                </div>
            </div>
        </div>
    )
}